import { Route, Routes } from "react-router";
import { NotFound } from "../../../app/pages/NotFound";
import { WILDCARD_ROUTE } from "../../../common/constants";
import { Permission } from "../../../common/security/enums";
import PageWithPermission from "../../auth/components/PageWithPermission";
import { PostponedCommissionListContainer } from "./containers/PostponedCommissionListContainer";

const routes = () => (
  <Routes>
    <Route
      index
      element={
        <PageWithPermission
          component={<PostponedCommissionListContainer />}
          permissions={[Permission.POSTPONED_COMMISSIONS]}
        />
      }
    />

    <Route path={WILDCARD_ROUTE} element={<NotFound />} />
  </Routes>
);

export default routes;
